<template>
	<div class="content">
		<div class="cont_title">学生管理</div>
		<div class="top">
			<el-input style="width: 280px;margin-right: 30px;" 
			@keyup.enter.native="getList" v-model="queryParams.keywords" placeholder="请输入学生姓名/学号查询" type="text"/>
			<el-button icon="el-icon-search" type="primary" @click="getList()">查询</el-button>
			<div class="top_rig"> 
				<!-- <div class="zujuan_btn">
					<img src="../../assets/img/tea3.png" alt="">
					<div>导入学生</div>
				</div> -->
				<el-upload :action="actionpost" :show-file-list="false" :headers="myHeaders"
				  :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
				 <div class="zujuan_btn">
				 	<img src="../../assets/img/tea3.png" alt="">
				 	<div>导入学生</div>
				 </div>
				</el-upload> 
				<div class="zujuan_btn btn1" @click="addTeacher()">
					<img src="../../assets/img/tea2.png" alt="">
					<div>新增学生</div>
				</div>
				<div class="zujuan_btn btn2" @click="delTeacher()">
					<img src="../../assets/img/tea1.png" alt="">
					<div>批量删除</div>
				</div>
			</div>
		</div>
		<el-table style="width: 100%;margin-top: 30px;" border v-loading="loading" :data="tableData" @selection-change="handleSelectionChange" :header-cell-style="{background: '#F5F6F7'}">
			<el-table-column type="selection" width="55" align="center" />
			<el-table-column prop="student_code" label="学号" align="center"/>
			<el-table-column prop="student_name" label="姓名" align="center"/>
			<el-table-column prop="class_name" label="班级" align="center"/>
			<el-table-column  label="性别" align="center">
				<template slot-scope="scope">
					<span v-if="scope.row.sex == 1">男</span>
					<span v-else>女</span>
				</template>
			</el-table-column>
			<el-table-column prop="phone" label="联系方式" align="center"/>
			<el-table-column  label="操作" align="center">
				<template slot-scope="scope">
					<el-button @click="editTeacher(scope.row)" type="text" size="small">编辑</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="block" style="margin-top: 20px;text-align: center;">
			<el-pagination background  @current-change="handleCurrentChange" 
			:current-page="currentPage" layout="prev, pager, next" :total="total"></el-pagination>
		</div>
		
		<!-- 添加学生 -->
		<el-dialog :visible.sync="open" :title="opentitle" width="800px" append-to-body>
			<el-form  ref="form" style="box-sizing: border-box;padding: 0 120px;" :model="form" :rules="rules" label-width="78px">
				<el-row>
				    <el-form-item label="学号" prop="student_code">
				      <el-input v-model="form.student_code" placeholder="请输入学号" type="text"/>
				    </el-form-item>
				</el-row>
				<el-row>
				    <el-form-item label="姓名" prop="student_name">
				      <el-input v-model="form.student_name" placeholder="请输入学生姓名" type="text"/>
				    </el-form-item>
				</el-row>
				<el-row>
				    <el-form-item label="年级" prop="newpsw">
				      <div style="display: flex;">
						  <el-select style="width: 50%;" v-model="form.education" placeholder="请选择学历">
						      <el-option
						        v-for="item in selist1"
						        :key="item.value"
						        :label="item.label"
						        :value="item.value">
						      </el-option>
						  </el-select>
						  <el-select style="width: 50%;" v-model="form.school_year" placeholder="请选择学年">
						      <el-option
						        v-for="item in selist2"
						        :key="item.value"
						        :label="item.label"
						        :value="item.value">
						      </el-option>
						  </el-select>
					  </div>
				    </el-form-item>
				</el-row>
				<el-row>
				    <el-form-item label="性别" prop="sex">
				      <el-select style="width: 100%;" v-model="form.sex" placeholder="请选择">
				          <el-option
				            v-for="item in selist"
				            :key="item.value"
				            :label="item.label"
				            :value="item.value">
				          </el-option>
				      </el-select>
				    </el-form-item>
				</el-row>
				<el-row>
				    <el-form-item label="联系方式" prop="phone">
				      <el-input v-model="form.phone" maxlength="11" placeholder="请输入联系方式" type="text"/>
				    </el-form-item>
				</el-row>
				<el-row>
				    <el-form-item label="密码" prop="password">
				      <el-input v-model="form.password" placeholder="请输入学生登录密码"  type="password"/>
				    </el-form-item>
				</el-row>
			</el-form>
		  
		   <div slot="footer" class="dialog-footer" style="text-align: center;">
		     <el-button @click="cancel">取 消</el-button>
				<el-button type="primary" @click="submitman">提 交</el-button>
		   </div>
		</el-dialog>
	</div>
</template>
<script>
import {add_student,student_details,edit_student,student_list,bact_delete_student} from "../../api/new.js";	
var token = localStorage.getItem('token') // 获取token	
	export default {
		data() {
			return {
				loading: true,
				tableData: [],
				queryParams:{
					keywords:'',
					limit:10,
					page:1,
					banji_id:'all',
				},
				total: 0,
				currentPage: 1,
				
				open:false,
				opentitle:'添加学生',
				editt:false,
				selist:[{value:1,label:'男'},{value:2,label:'女'}],
				selist1:[{value:'博士',label:'博士'},{value:'硕士',label:'硕士'},{value:'本科',label:'本科'},{value:'专科',label:'专科'}],
				selist2:[{value:'2017-2018',label:'2017-2018'},{value:'2018-2019',label:'2018-2019'},{value:'2019-2020',label:'2019-2020'},
				{value:'2020-2021',label:'2020-2021'},{value:'2021-2022',label:'2021-2022'},{value:'2022-2023',label:'2022-2023'},
				{value:'2023-2024',label:'2023-2024'},{value:'2024-2025',label:'2024-2025'},{value:'2025-2026',label:'2025-2026'},
				{value:'2026-2027',label:'2026-2027'},{value:'2027-2028',label:'2027-2028'},{value:'2028-2029',label:'2028-2029'},
				{value:'2029-2030',label:'2029-2030'},
				],
				form:{
					student_code:'',
					student_name:'',
					phone:'',
					sex:'',
					password:'',
				},
				rules:{},
				ids:[],
				
				actionpost: 'http://ws-nocode.com:81/index.php/manager/student/dodaoru',
				myHeaders: {
				  token: token
				},
			};
		},
		
		mounted() {
			this.getList()
		},
		methods: {
			handleAvatarSuccess(res, file) {
			  if (res.code == 0) {
				  this.$message.success(res.msg);
				  this.getList()
			  } else {
			    this.$message.error(res.msg);
			  }
			},
			beforeAvatarUpload(file) {
			  // const isJPG = file.type === 'image/jpeg';
			  // const isLt2M = file.size / 1024 / 1024 < 2;
			},
			//列表
			getList(){
				var _this = this
				this.loading = true
				student_list(this.queryParams).then((res) => {
					this.loading = false
					if (res.code == 0) {
						this.tableData = res.data
						this.total = res.total
					} else {
						this.$message.error(res.msg);
					} 
				})
				.catch((err) => {
					this.loading = false
				});	
			},
			//删除
			delTeacher(){
				var _this = this
				if(this.ids.length > 0){
					var idd = this.ids.toString()
					var data = { id:idd }
					this.$confirm('您确定要删除吗？', "提示", {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "warning",
						}).then(() => {
							bact_delete_student(data).then((res) => {
								if (res.code == 0) {
									_this.$message.success(res.msg);
									_this.getList()
								} else {
									this.$message.error(res.msg);
								}
							  }).catch((err) => {
									console.log(err);
							  });
						}).catch(() => {});
				}
			},
			//新增打开
			addTeacher(){
				this.form = {}
				this.editt = false
				this.open = true
				this.opentitle ='添加学生'
			},
			//编辑打开
			editTeacher(e){
				var _this = this
				var data = { id:e.id }
				student_details(data).then((res) => {
					if (res.code == 0) {
						_this.form = res.data
						_this.open = true
						_this.editt = true
						_this.opentitle ='编辑学生'
					} else {
						this.$message.error(res.msg);
					}
				  })
				  .catch((err) => {
						console.log(err);
				  });
			},
			//取消
			cancel(){
				this.form = {}
				this.open = false
				this.editt = false
			},
			//新增编辑确定
			submitman(){
				var _this = this
				if(this.editt){
					//修改
					edit_student(this.form).then((res) => {
						if (res.code == 0) {
							_this.$message.success(res.msg);
							_this.cancel()
							_this.getList()
						} else {
							_this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						console.log(err);
					});
				}else{
					// 新增
					add_student(this.form).then((res) => {
						if (res.code == 0) {
							_this.$message.success(res.msg);
							_this.cancel()
							_this.getList()
						} else {
							_this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						console.log(err);
					});
				}
			},
			
			
			// 多选框选中数据
			handleSelectionChange(selection) {
				this.ids = selection.map(item => item.id)
			},
			//上一页，下一页
			handleCurrentChange(currentPage) {
				this.queryParams.page = currentPage;
				this.currentPage = currentPage;
				this.getList()
			}
		},
	};
</script>
<style lang="less" scoped>
div{
	box-sizing: border-box;
}
.content{
	width: 100%;
	min-width: 1200px;
	background: #FFFFFF;
	border-radius: 20px;
	padding: 30px;	
	
	.top{
		width: 100%;
		display: flex;
		align-items: center;
		// justify-content: space-between;
		margin-top: 50px;
		.top_rig{
			display: flex;
			margin-left: auto;
		}
		.zujuan_btn{
			width: 140px;
			height: 44px;
			background: #4076F3;
			border-radius: 10px;
			font-size: 16px;
			color: #FFFFFF;
			line-height: 44px;
			text-align: center;
			cursor: pointer;
			margin-left: 35px;
			display: flex;
			align-items: center;
			justify-content: center;
			img{
				width: 24px;
				height: 24px;
				margin-right: 6px;
			}
		}
		.btn1{
			background: #ED7F26;
		}
		.btn2{
			background: #E13049;
		}
		.zujuan_btn:hover{
			opacity: 0.7;
		}
		.zujuan_btn:active{
			opacity: 0.9;
		}
	}
	
}	
</style>



// WEBPACK FOOTER //
// src/components/xuesheng/xStudent.vue